// extracted by mini-css-extract-plugin
export default {"form":"selector_form__l+W9I","select":"selector_select__Z9QBn","label":"selector_label__knbN7"};